import type { IAppManagementByDeviceType } from '~/types/application-management'
import type { IAppOption } from '~/types/option'

import { FASTLY_PATH } from '~/const/asset'
import { useAppsManagementListQuery } from '~/queries/application-management'
import { splitByDeviceType } from '~/utils/application'
import { resize } from '~/utils/media'

const useApps = (): {
  appKeys: Pick<IAppOption, 'appKey' | 'label' | 'url'>[]
  appsOptions: IAppOption[]
  isAppsLoading: boolean
} => {
  const { data: apps, isLoading: isAppsLoading } = useAppsManagementListQuery()

  const appsOptions: IAppOption[] =
    apps
      ?.reduce(splitByDeviceType(), [] as IAppManagementByDeviceType[])
      .map(({ app_key, default_display_name, device_type, icon_file_id }) => ({
        appKey: app_key,
        deviceType: device_type,
        label: default_display_name,
        url: icon_file_id ? resize(`${FASTLY_PATH}${icon_file_id}`, 32, 32) : '',
        value: JSON.stringify({ app_key, device_type }),
      }))
      .sort(({ label: aName }, { label: bName }) => aName.localeCompare(bName)) || []

  const appKeys =
    apps?.map(({ app_key, default_display_name, icon_file_id }) => ({
      appKey: app_key,
      label: default_display_name,
      url: icon_file_id ? resize(`${FASTLY_PATH}${icon_file_id}`, 32, 32) : '',
    })) || []

  return { appKeys, appsOptions, isAppsLoading }
}

export default useApps
